import React from 'react';
import { Purchases } from '../../components/Purchases';

export const MainPage: React.FC = (): JSX.Element => {
	return <Purchases />;
};
